import React from "react";
import { FiSearch, FiFilter } from "react-icons/fi";
import { NotificationCategory, NotificationPriority } from "../../../utils/api/endpoints/notificationsApi";

interface NotificationFilterBarProps {
  searchTerm: string;
  onSearchChange: (val: string) => void;
  selectedCategory: string;
  onCategoryChange: (val: string) => void;
  selectedPriority: string;
  onPriorityChange: (val: string) => void;
  showUnreadOnly: boolean;
  onShowUnreadOnlyChange: (val: boolean) => void;
  sortBy: string;
  onSortByChange: (val: string) => void;
}

const NotificationFilterBar: React.FC<NotificationFilterBarProps> = ({
  searchTerm,
  onSearchChange,
  selectedCategory,
  onCategoryChange,
  selectedPriority,
  onPriorityChange,
  showUnreadOnly,
  onShowUnreadOnlyChange,
  sortBy,
  onSortByChange
}) => {
  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 p-4 bg-white border border-gray-200 rounded-xl mb-6 shadow-sm">
      {/* Search Input */}
      <div className="relative flex-1">
        <FiSearch className="absolute left-3.5 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
        <input
          type="text"
          placeholder="Search notifications..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full pl-10 pr-4 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#010D2C]/30 focus:border-[#010D2C] transition-all"
        />
      </div>

      {/* Select Filters & Checkbox */}
      <div className="flex flex-wrap items-center gap-4">


        {/* Priority Dropdown */}
        <div className="relative">
          <select
            value={selectedPriority}
            onChange={(e) => onPriorityChange(e.target.value)}
            className="appearance-none bg-white pl-4 pr-10 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#010D2C]/30 focus:border-[#010D2C] transition-all cursor-pointer text-gray-700"
          >
            <option value="all">All Priorities</option>
            <option value={NotificationPriority.Low}>Low</option>
            <option value={NotificationPriority.Normal}>Normal</option>
            <option value={NotificationPriority.High}>High</option>
            <option value={NotificationPriority.Critical}>Critical</option>
          </select>
          <div className="absolute right-3.5 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
            <FiFilter className="w-3.5 h-3.5" />
          </div>
        </div>

        {/* Unread Checkbox */}
        <label className="flex items-center gap-2 cursor-pointer select-none text-sm text-gray-600 font-medium hover:text-gray-900 transition-colors">
          <input
            type="checkbox"
            checked={showUnreadOnly}
            onChange={(e) => onShowUnreadOnlyChange(e.target.checked)}
            className="w-4 h-4 rounded border-gray-300 text-[#010D2C] focus:ring-[#010D2C]"
          />
          Show unread only
        </label>

        {/* Sort By Dropdown */}
        <div className="flex items-center gap-2">
          <span className="text-xs font-semibold text-gray-400 uppercase tracking-wide">Sort by:</span>
          <select
            value={sortBy}
            onChange={(e) => onSortByChange(e.target.value)}
            className="bg-transparent py-1.5 border-b border-gray-300 rounded-none text-sm focus:outline-none focus:border-[#010D2C] transition-all cursor-pointer font-bold text-gray-800"
          >
            <option value="newest">Newest</option>
            <option value="oldest">Oldest</option>
            <option value="priority">Priority</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default NotificationFilterBar;
